export default __webpack_public_path__ + "static/media/chat_usuário_comum.4e58a5a4.mp4";